import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomTextField from "components/mui/text-field";

// API
import { SaveSkills } from "screens/Settings/logic/skillsapi";

const AddSkillType = ({ 
  open, 
  handleClose, 
  navigate, 
  loadData , 
  fetchSkillDetails, 
  skill,
  handleChange,
  SkillContent,
  toast,
}) => {
  const theme = useTheme();

  const [skillName, setSkillName] = useState("");
  const [loading, setLoading] = useState(false);
  
  // useEffect(() => {
  //   if (open) {
  //     if (entity === "edit" && selectedSkill?.skillID) {
  //       setSkillName(selectedSkill.skillID);
  //     } else {
  //       setSkillName("");
  //     }
  //   }
  // }, [open, selectedSkill, entity]);

  const handleSubmit = async () => {
    if (!skill?.skillName.trim()) return;

    setLoading(true);    

    const response = await SaveSkills(skill, navigate);

    if (!response.isError) {
      toast.success(
        SkillContent.entity === "edit" ? "Skill type updated successfully" : "Skill type created successfully"
      , {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      handleClose();
      loadData?.();
      fetchSkillDetails(0);
    } else {
      toast.error(response.message || "Failed to save skill type", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      console.error("Error saving skill type:", response.message);
    }

    setLoading(false);
  };

  return (    
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      {/* {console.log('Skill', skill)} */}
      <DialogTitle
        sx={{
          borderBottom: "1px solid #D9D9D9",
          paddingBottom: "20px !important",
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          {SkillContent.title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={5}>
          <Grid item xs={12} md={8}>
            <CustomTextField
              fullWidth
              label="Skill Type"
              value={skill.skillName}
              onChange={(e) => handleChange('skillName', e.target.value)}
              placeholder="Enter your desired skill name"
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "20px 24px !important",
          boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
          zIndex: 1,
        }}
      >
        <Button variant="contained" color="info" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
  variant="contained"
  color="main"
  onClick={handleSubmit}
  disabled={!skill?.skillName.trim() || loading}
>
  {loading ? "Saving..." : (SkillContent.entity === "edit" ? "Save Changes" : "Save Skill Type")}
</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSkillType;
